// Source: https://github.com/lodash/lodash/issues/2240#issuecomment-448982405
import { set } from 'lodash-es';

export const unflatten = (object: Record<string, string[] | never> | null): Record<string, string[]> => Object
  .entries(object || {})
  .reduce((accumulator, [k, v]) => set(accumulator, k, v), {});
